// extracted by mini-css-extract-plugin
export default {"titleContainer":"title_titleContainer__lKhiX","title":"title_title__Ki0CM","subtitle":"title_subtitle__MeoDW"};